module.exports = __webpack_public_path__ + "static/media/painter.139ac45b.jpeg";